<template lang="pug">
  vSelect.groups-multiple-select(:value="selectedArray" :options="options" label="name" @input="onInput" :placeholder="loading ? 'Loading...' : placeholder" :disabled="loading === true || disabled === true" multiple)
</template>

<script>
import vSelect from 'vue-select'
import Security from '@/service/apis/Security'

export default {
  props: {
    value: {
      type: null
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    options: [],
    selectedArray: [],
    placeholder: 'Select Groups',
    loading: false
  }),
  created() {
    this.loading = true
    Security.listGroups({ size: 1000 })
      .then((resp) => {
        this.options = resp.data.content
      })
      .catch((e) => {
        this.placeholder = e.response.data.message
      })
      .then(() => {
        this.loading = false
      })
  },
  methods: {
    onInput(val) {
      this.$emit('input', val && val.length > 0 ? val.map((v) => v.id) : [])
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/GroupsMultipleSelect.vue